import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { WidgetECommerceService } from "./service/widget-e-commerce.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "widget-e-commerce",
  templateUrl: "./widget-e-commerce.component.html",
  styleUrls: ["./widget-e-commerce.component.scss"],
  providers: [WidgetECommerceService]
})
export class WidgetECommerceComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions;
  ErrMsg;

  constructor(
    private translateService: TranslateService,
    private dataService: WidgetECommerceService
  ) { }

  ngAfterViewInit() {
    this.getEcommerce();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getEcommerce();
    }
  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.TRANSFER.REASON_FOR_FAILURE").pipe(takeUntil(this.unsubscribe))
      .subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
  }

  getEcommerce() {
    const params = {};
    this.dataService.getEcommerce(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          this.chartOptions = this.dataService.createChart(
            chartData,
            this.OPTIONS
          );
        },
        err => {
          this.ErrMsg = "Not able to Load";
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
 
}
